const AUTH_TOKEN_KEY = 'auth_token';

/** Minutes before expiry to show session warning */
export const SESSION_WARNING_MINUTES = 5;

/**
 * Check if a JWT token is expired.
 * @param {string|null} token - JWT token string
 * @returns {boolean} true if expired or invalid
 */
export function isTokenExpired(token) {
    if (!token) return true;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}

/**
 * Check if token is about to expire (within SESSION_WARNING_MINUTES).
 * @param {string|null} token - JWT token string
 * @returns {boolean} true if expiring soon
 */
export function isTokenExpiringSoon(token) {
    if (!token) return false;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expMs = payload.exp * 1000;
        const warningThreshold = Date.now() + SESSION_WARNING_MINUTES * 60 * 1000;
        return expMs > Date.now() && expMs < warningThreshold;
    } catch {
        return false;
    }
}

/**
 * Get stored token without expiry check (for refresh attempt).
 * @returns {string|null} Raw token from storage
 */
export function getStoredToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function getAuthToken() {
    const token = getStoredToken();
    return isTokenExpired(token) ? null : token;
}

export function setAuthToken(token) {
    if (token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    }
}

export function clearAuthToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
}
